<template>
	<JBox class="s-max-w-lg">
		<CFormInput
			name="name"
			:label="$t('templates.name')"
			componentName="JInputText"
			:value="value.name"
			@input="$emit('input', { ...value, name: $event })"
			class="s-mb-6"
		/>
		<CFormInput
			name="description"
			:label="$t('templates.description')"
			componentName="JInputText"
			:value="value.description"
			@input="$emit('input', { ...value, description: $event })"
			class="s-mb-6"
		/>
		<CFormInput
			name="logicalId"
			:label="$t('templates.logicalId')"
			componentName="JInputText"
			:value="value.logicalId"
			@input="$emit('input', { ...value, logicalId: $event })"
		/>
		<slot />
	</JBox>
</template>

<script>
export default {
	props: {
		value: {
			type: Object,
			default: () => ({})
		}
	}
}
</script>
